"use strict";

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.array.iterator");

var keysL = require("../Lazy/keysL.js");

var isIterable = require("./isIterable.js");

module.exports = isEmpty;

function isEmpty(a) {
  if (isIterable(a)) {
    return a[Symbol.iterator]().next().done;
  } else if (a !== null && typeof a === 'object') {
    return isEmpty(keysL(a));
  } else {
    return false;
  }
}